import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import {
    faUser,
    faUserCheck,
    faFileLines,
    faSirenOn,
    faSparkles,
    faExclamationTriangle,
    faPhone,
    faVideo,
    faBuilding,
    faBell,
    faQuestion,
    faUserGraduate,
    faExternalLink,
    faCalendarStar
} from '@fortawesome/pro-solid-svg-icons';
import { faPen, faTrashCan } from '@fortawesome/pro-light-svg-icons';
import { faCalendarExclamation, faCheck } from '@fortawesome/pro-regular-svg-icons';

export function initFontAwesome() {
    library.add(
        faUser,
        faUserCheck,
        faFileLines,
        faSirenOn,
        faSparkles,
        faPen,
        faTrashCan,
        faCalendarExclamation,
        faExclamationTriangle,
        faCheck,
        faPhone,
        faVideo,
        faBuilding,
        faBell,
        faQuestion,
        faUserGraduate,
        faExternalLink,
        faCalendarStar
    );
    Vue.component('font-awesome-icon', FontAwesomeIcon);
}